import { API_URL_PROJECT } from "@constants/env";
import { ProjectFeatureType } from "@enums/projectFeatureType";
import apiInstance from "@services/Shared/instanceAxios";

const featureProject = (
  uuid: string,
  unlist: boolean = false,
  type?: ProjectFeatureType,
  order?: number
) =>
  apiInstance({
    url: `${API_URL_PROJECT}${uuid}/featured`,
    method: "put",
    data: { unlist, type, order },
  });

export default featureProject;
